module.exports = "../../../../platform/assets/pageMainIcon/youth_baobiaochaxunlei4.svg";